














import { Vue, Component } from "@/shared/vuepack";
import LegalEntity from "@/shared/legalEntity";

@Component
export default class HsaBankOnboardingFooter extends Vue {
  readonly currentYear = new Date().getFullYear();

  get divisionName () {
    return LegalEntity.divisionName;
  }
}
